import Vue from 'vue'
import router from '@/router'
import VueAnalytics from 'vue-analytics'

const initializeAnalytics = (userId: string) => {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID,
    fields: {
      userId: userId,
    },
    debug: {
      enabled: false,
    },
    router,
  })
}

export default initializeAnalytics
